import React from "react"
import { components } from "react-select"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DropdownIndicator = (props: any) => {
    return (
        <components.DropdownIndicator {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6.676" viewBox="0 0 11 6.676">
                <path
                    id="chevron-down"
                    className="chevron-down"
                    d="M5.47,15.182l-4.9-4.9a.6.6,0,0,1,0-.855l.571-.571a.6.6,0,0,1,.854,0l3.9,3.88,3.9-3.88a.6.6,0,0,1,.854,0l.571.571a.6.6,0,0,1,0,.855l-4.9,4.9A.6.6,0,0,1,5.47,15.182Z"
                    transform="translate(-0.398 -8.683)"
                    fill="#22253F"
                />
            </svg>
        </components.DropdownIndicator>
    )
}
